import React, { useMemo, useState } from 'react';
import {
  Section,
  SelectionGroup,
  SelectionGroupValue,
  SelectionGroupOption,
  Gallery,
} from 'common/components';
import { analyticsUtils } from 'utils/analytics-utils';
import { CABINET_ELEMENT_BLOCK } from '../../cabinet-constants';
import { SELECTION_GROUP_LIST } from './cabinet-gallery-constants';
import { getImageList } from './cabinet-gallery-utils';
import {
  cabinetGalleryGrid,
  cabinetGalleryImageWrapper,
  cabinetGallerySectionTabs,
} from './cabinet-gallery-styles';

const INITIAL_IMAGES_PER_PAGE = 5;
const IMAGES_PER_PAGE = 6;

type CabinetGalleryProps = {
  signUpHref: string;
}

export const CabinetGallery: React.FC<CabinetGalleryProps> = ({ signUpHref }) => {
  const [activeTab, setActiveTab] = useState<string>('all');

  const collectionList = useMemo(() => getImageList(activeTab), [activeTab]);

  const handleTabChange = (e: React.MouseEvent, value: SelectionGroupValue) => {
    if (value !== activeTab) {
      setActiveTab(value as string);
    }

    const activeOption: SelectionGroupOption | undefined = SELECTION_GROUP_LIST.find(
      (option: SelectionGroupOption) => option.value === value
    );
    if (activeOption) {
      analyticsUtils.clickButtonEvent(
        `${CABINET_ELEMENT_BLOCK}`,
        activeOption.text,
        'Выберите свой стиль'
      );
    }
  };

  return (
    <Section>
      <SelectionGroup
        className={cabinetGallerySectionTabs}
        active={activeTab}
        onChange={handleTabChange}
        optionList={SELECTION_GROUP_LIST}
        rounded
      />

      <Gallery
        elementBlock={CABINET_ELEMENT_BLOCK}
        elementText="Галерея проектов"
        imageList={collectionList}
        imagePerPage={IMAGES_PER_PAGE}
        initialImagePerPage={INITIAL_IMAGES_PER_PAGE}
        isShowImageName
        isShowImageAddText
        galleryGridClassName={cabinetGalleryGrid}
        galleryImageClassName={cabinetGalleryImageWrapper}
        modalBtnProps={{
          href: signUpHref,
          title: 'Записаться на проектирование',
        }}
      />
    </Section>
  );
}
